module.exports = __webpack_public_path__ + "static/media/sms-campaigns.5fe87792.svg";